<template>
  <div class="editor-module-container">
    <div class="editor-module-title">
      <div
        class="left-content"
        @click="clickRenameModule('', customModuleTitle)"
      >
        <img
          v-if="moduleIcon"
          class="module-icon"
          :src="moduleIcon"
          alt=""
        />
        <div class="module-title">{{ customModuleTitle }}</div>
        <i class="iconfont iconedit-"></i>
        <div
          v-if="issueCount"
          class="module-issue-count"
        >
          {{ issueCount }} 项待修复
        </div>
      </div>
      <div class="right-content">
        <i
          v-if="$store.state.editor[moduleType] && $store.state.editor[moduleType].length"
          class="iconfont iconchevron-down"
          style="margin-right: 14px"
          :class="{ active: editId === $store.state.editor[moduleType][0].id }"
          @click="editIdChange($store.state.editor[moduleType][0].id)"
        ></i>
        <i
          class="iconfont iconshanchujianli"
          @click="handleClickRemoveModule"
        ></i>
      </div>
    </div>
    <div class="editor-form-list">
      <div
        v-for="item in $store.state.editor[moduleType]"
        :key="item.id"
        :id="`experience${item.id}`"
        class="editor-form-content"
        @click="editIdChange(item.id)"
      >
        <div class="form-item-header">
          <div
            v-if="item.description && editId !== item.id"
            class="form-item-content"
            style="margin-top: 0"
          >
            <div
              class="content-text description-content-text"
              v-html="item.description"
            ></div>
          </div>
        </div>
        <el-collapse-transition>
          <div
            v-show="editId === item.id"
            class="editor-module-content"
            @click.stop
          >
            <EditorRichText
              :description="item.description"
              :placeholder="placeholder"
              :formData="item"
              :editId="editId"
              style="width: 100%"
              @contentChange="contentChange($event, item)"
              @editorFocus="editorFocus(item)"
            />
            <EditorAdviceBlock
              :item="item"
              :module="moduleType"
              :checkResult="checkResult"
              :suggestionList="returnCheckResultList(item.id, suggestionsModule)"
              :singleCheckLoading="singleCheckLoading"
              :repairIssueLoading="repairIssueLoading"
              @singleExperienceCheck="clickSingleExperienceCheck"
              @saveExperience="saveCustomExperience"
              @resolveIssue="resolveIssue"
              @clickIgnore="clickIgnore"
              @buyMember="buyMember"
              @useOptimizationContent="useOptimizationContent"
            />
            <div class="complete-button-wrapper">
              <CompleteButton
                text="保存"
                :disabled="!item.description"
                @clickBtn="saveCustomExperience(item.id, 'click')"
              />
            </div>
          </div>
        </el-collapse-transition>
      </div>
      <div
        v-if="displayAddBtn"
        class="editor-module-add"
        @click="clickAddExperience"
      >
        <i class="iconfont iconplus-circle"></i>
        <span>添加一段{{ customModuleTitle }}</span>
      </div>
    </div>

    <RenameModuleModal
      ref="renameModalRef"
      @confirm="confirmModuleRename($event, moduleId)"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import EditorRichText from '../EditorRichText/EditorRichText.vue';
import { editorFormMixin } from '../../mixins/editor-form';
import RenameModuleModal from '../RenameModuleModal/RenameModuleModal.vue';
import CompleteButton from '../CompleteButton/CompleteButton.vue';
import EditorAdviceBlock from '../EditorAdviceBlock/EditorAdviceBlock.vue';

export default {
  name: 'EditorSkillPersonal',
  mixins: [editorFormMixin],
  components: {
    EditorRichText,
    RenameModuleModal,
    CompleteButton,
    EditorAdviceBlock,
  },
  props: {
    editId: {
      type: [String, Number],
      default: '',
    },
    moduleId: {
      type: Number,
      default: '',
    },
    moduleType: {
      type: String,
      default: '',
    },
    suggestionsModule: {
      type: Object,
      default: () => ({}),
    },
    saveLoading: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    editId(_, oldVal) {
      if (this.clickSaveBtn) return;
      this.saveCustomExperience(oldVal);
    },
  },
  computed: {
    ...mapState('editor', ['cvDetail']),
    displayAddBtn() {
      return this.$store.state.editor[this.moduleType].length === 0;
    },
    moduleTitle() {
      const { submodule_info } = this.cvDetail;
      const { custom_sections_titles } = submodule_info;
      return custom_sections_titles[`${this.moduleId}_title`];
    },
    placeholder() {
      const {
        basic_info: { cv_type },
      } = this.cvDetail;
      switch (this.moduleType) {
        case 'skill_list':
          return '按照 “技能领域：编程语言（掌握程度）” 的格式罗列专业技能，如：Web开发：Python（熟练）';
        case 'personal_summary':
          return cv_type.includes('grad') ? '简短分条地总结与申请专业相关的经验、技能以及能力' : '简短分条地总结与申请岗位相关的经验、技能以及能力';
      }
    },
  },
  methods: {
    editIdChange(id) {
      if (id === this.editId) {
        this.$emit('editItem', '');
      } else {
        this.$emit('editItem', id);
      }
    },
    clickSingleExperienceCheck(item, type) {
      if (this.singleCheckLoading) return;
      this.singleCheckLoading = true;
      this.saveCustomExperience(item.id, false, async () => {
        await this.singleExperienceCheck(item, type);
        this.singleCheckLoading = false;
      });
    },
    saveCustomExperience(id, operation, callback) {
      const payload = this.$store.state.editor[this.moduleType].find((item) => item.id === id);
      if (!payload || !payload.description) return;
      payload.lang = this.cvDetail.basic_info.lang;
      payload.custom_section_id = this.moduleId;
      this.updateFormCustomExperience(payload, this.moduleId, this.moduleType, operation, callback);
    },
    async resolveIssue(item, type) {
      this.repairIssueLoading = true;
      const result = await this.clickRepairIssue(item, type);
      this.repairIssueLoading = false;
      if (result === 'success') {
        this.saveCustomExperience(item.id);
      }
    },
    async handleClickRemoveModule() {
      const confirm = await this.$wondercv.showConfirm({
        title: '温馨提示',
        content: `确定要删除${this.customModuleTitle}吗？`,
        warningText: '模块删除后无法恢复',
        confirmText: '确认',
        cancelText: '取消',
      });
      if (confirm) {
        this.clickRemoveModule(this.moduleId);
      }
    },
    editorFocus(item) {
      this.$emit('editItem', item.id);
    },
    contentChange(content, item) {
      item.description = content;
    },
    clickAddExperience() {
      this.$store.commit('editor/setModuleData', {
        type: this.moduleType,
        info: [
          {
            id: `${this.moduleId}-edit`,
            description: '',
          },
        ],
      });
      this.$emit('editItem', `${this.moduleId}-edit`);
    },
    buyMember() {
      this.$emit('buyMember');
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/variable.scss';
@import '../../styles/editor.scss';
</style>
